import React from 'react';
import { translate } from 'react-i18next';

class OfflineBanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOnline: Utils.isOnline(),
      cachedAt: null,
    };
    this._onOnline = this._onOnline.bind(this);
    this._onOffline = this._onOffline.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    OfflineStore.on('app:online', this._onOnline);
    OfflineStore.on('app:offline', this._onOffline);
    // After a page refresh in offline mode the online/offline events don't
    // fire, so seed the timestamp from IndexedDB immediately.
    if (!Utils.isOnline()) {
      OfflineCache.getLatestCachedAt().then(cachedAt => {
        if (this._isMounted) this.setState({ cachedAt: cachedAt || null });
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    OfflineStore.off('app:online', this._onOnline);
    OfflineStore.off('app:offline', this._onOffline);
  }

  _onOnline() {
    this.setState({ isOnline: true, cachedAt: null });
  }

  _onOffline() {
    OfflineCache.getLatestCachedAt().then(cachedAt => {
      if (this._isMounted) this.setState({ isOnline: false, cachedAt: cachedAt || null });
    });
  }

  _formatCachedAt(ts) {
    return moment(ts).fromNow();
  }

  render() {
    if (this.state.isOnline) return null;

    const { t } = this.props;

    return (
      <div
        id="offline-banner"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        className="offline-banner"
      >
        <span className="offline-banner__icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="1" y1="1" x2="23" y2="23"/>
            <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"/>
            <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"/>
            <path d="M10.71 5.05A16 16 0 0 1 22.56 9"/>
            <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"/>
            <path d="M8.53 16.11a6 6 0 0 1 6.95 0"/>
            <line x1="12" y1="20" x2="12.01" y2="20"/>
          </svg>
        </span>
        <span className="offline-banner__text">
          {this.state.cachedAt
            ? t('OfflineBanner.you_are_offline_with_time', {
                time: this._formatCachedAt(this.state.cachedAt),
              })
            : t('OfflineBanner.you_are_offline')}
        </span>
      </div>
    );
  }
}

export default translate()(OfflineBanner);
